import type { ReactNode } from 'react'
import { LandingNav } from './LandingNav'
import { SiteFooter } from './SiteFooter'

interface LandingShellProps {
  children: ReactNode
}

export function LandingShell({ children }: LandingShellProps) {
  return (
    <div className="relative min-h-screen overflow-hidden bg-app-bg text-text-primary">
      <div
        className="pointer-events-none absolute inset-0 z-0 bg-[radial-gradient(ellipse_80%_50%_at_50%_-20%,rgba(129,140,248,0.25),transparent)]"
        aria-hidden
      />
      <div
        className="pointer-events-none absolute -right-32 top-1/3 z-0 h-96 w-96 rounded-full bg-accent/10 blur-3xl"
        aria-hidden
      />
      <div
        className="pointer-events-none absolute -left-24 bottom-0 z-0 h-80 w-80 rounded-full bg-status-up/5 blur-3xl"
        aria-hidden
      />

      <div className="relative z-10 flex min-h-screen flex-col">
        <LandingNav />
        <main className="flex-1">{children}</main>
        <footer className="border-t border-border-subtle px-4 py-6 sm:px-8">
          <SiteFooter />
        </footer>
      </div>
    </div>
  )
}
